import { render } from "./famousCourseHumanityVideo.vue?vue&type=template&id=0820b8d2&scoped=true"
import script from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"

import "./famousCourseHumanityVideo.vue?vue&type=style&index=0&id=0820b8d2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0820b8d2"]])

export default __exports__